import { render, staticRenderFns } from "./Well.vue?vue&type=template&id=6d1a6c2c&scoped=true"
import script from "./Well.vue?vue&type=script&lang=js"
export * from "./Well.vue?vue&type=script&lang=js"
import style0 from "./Well.vue?vue&type=style&index=0&id=6d1a6c2c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1a6c2c",
  null
  
)

export default component.exports